import { render } from "./TheSharingContainer.vue?vue&type=template&id=3a45b737"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__